import React, { useState } from "react";
import styles from "./../Hostels/houses.module.css";
import styless from './style.module.css';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import { Link, useNavigate } from "react-router-dom";
import { getsessionuser } from '../Utils/sessions';
import Universalheader from "../Headers/universalheader";




const Faqs = () => {

    const navigate = useNavigate();
    const user = getsessionuser();
    const [showmessage, setshowmessage] = useState(false);
    const [id, setid] = useState('');


    // setInterval(() => {
    //     var currentdate = new Date();
    //     setcurrentdate(currentdate)
    // }, 10000);




    const questions = [
        {
            question: "What is Eazistey",
            answer: "Eazistey is an accommodation finder platform. We are a one-click s accommodation platform providing free assistance to tenants. We serve over 100 cities, and partnered with multiple field agents and property consultants who provide us updated listings. After recieving your preferences like distance from you, budget, bedroom configurations, safety etc. our platform finds out the apartments which fulfill your needs.",
            id: 1
        },
        {
            question: "What does the rent include ?",
            answer: "Rent includes all other payments included by the property owner in the other payments sections",
            id: 2
        },
        {
            question: "Are the properties safe and convenient?",
            answer: "Most of the properties are safe and are under CCTV surveillance. They are also in close proximity to major access roads and have multiple transport links that connect them to the entire city.",
            id: 3
        },
        {
            question: "Are the prices negotiable?",
            answer: "We make sure that you get the best value for your money. The prices that you see on our website are absolute and inherent. However you can get special offers exclusively from Eazistey",
            id: 4
        },
        {
            question: "Do I need to pay a deposit? When will I get my deposit back?",
            answer: "All deposits and other payments are sorted out between you and the property manager or caretaker",
            id: 5
        },
        {
            question: "Will I have basic amenities and appliances?",
            answer: "Yes, most of the properties provide basic amenities and appliances.",
            id: 6
        },
        {
            question: "Is the google map location accurate",
            answer: "Yes, We've made sure that the coordinates are accurate and navigates you to the exact property of your choosing",
            id: 7
        }
    ]



    // const viewallrestaurants = () => {
    //     document.getElementById("gh").scrollIntoView({ behavior: 'smooth' });
    // }

    return (
        <div className={styles.container}>
            <div className={styles.topheader} style={{ paddingBottom: 100 }}>
                <Universalheader />
                <div className={styles.housenamediv}>
                    <div className={styles.housenamehead}>{user?.username}</div>
                    <div>
                    </div>
                </div>
                <div className={styles.linksdiv}>
                    <Link to="/">
                        <a>Home  /</a>
                    </Link>
                    <a onClick={() => navigate("/nav/hostels")} style={{ cursor: "pointer" }}>properties  /</a>
                    <a style={{ cursor: "pointer" }}>faq's</a>
                </div>
                <div className={styles.bodydiv}>
                    <div className={styles.housedetailsdiv}>
                        <div className={styless.allfaqsdiv}>
                            {questions.map((val, key) => {
                                return (
                                    <div className={styless.faqdiv} key={key}>
                                        <div style={{ display: "flex" }}>
                                            <div className={styless.question}>{val.question}</div>
                                            <div className={styless.viewicons}>{showmessage && id === val.id ? <FaAngleUp onClick={() => {
                                                setid('')
                                                setshowmessage(false)
                                            }} /> : <FaAngleDown onClick={() => {
                                                setid(val.id)
                                                setshowmessage(true)
                                            }} />} </div>
                                        </div>
                                        {id === val.id && showmessage && <div className={styless.answer}>{val.answer}</div>}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Faqs;